import { Link } from "react-router-dom";
import nextDouble from "../assets/images/icons/next-double.svg";
import { useTranslation } from "../components/Localization";
import RoomPage from "../components/RoomPage";

export default function WarRoomPage() {
  const { t } = useTranslation();
  return <RoomPage roomId="war" slug="vilaghaboru" className="war-page" heroClassName="war-room-hero" headingClassName="war-heading" bottomClassName="war-room-bottom" navigation={<Link className="war-room-next" to="/vilaghaboru/bombazas" aria-label={t("common.next")}><img src={nextDouble} alt="" /></Link>} />;
}
